
import { z } from "zod";

export const formSchema = z.object({
  nom: z.string().min(2, {
    message: "Le nom doit contenir au moins 2 caractères.",
  }),
  prenom: z.string().min(2, {
    message: "Le prénom doit contenir au moins 2 caractères.",
  }),
  email: z.string().email({
    message: "Veuillez entrer une adresse email valide.",
  }),
  telephone: z.string().min(10, {
    message: "Veuillez entrer un numéro de téléphone valide.",
  }),
  adresse: z.string().min(5, {
    message: "L'adresse doit contenir au moins 5 caractères.",
  }),
  codePostal: z.string().min(5, {
    message: "Veuillez entrer un code postal valide.",
  }),
  ville: z.string().min(2, {
    message: "La ville doit contenir au moins 2 caractères.",
  }),
  typeBenne: z.string({
    required_error: "Veuillez sélectionner un type de benne.",
  }),
  typeDechet: z.string({
    required_error: "Veuillez sélectionner un type de déchet.",
  }),
  jours: z.string().min(1, {
    message: "Veuillez indiquer le nombre de jours de location.",
  }),
  dateDebut: z.string({
    required_error: "Veuillez indiquer une date de début de location.",
  }),
  commentaire: z.string().optional(),
});

export type FormValues = z.infer<typeof formSchema>;
